import React, { useState, useEffect, useRef, useCallback } from "react";

const hdrs = () => ({ "Content-Type": "application/json", Authorization: "Bearer " + sessionStorage.getItem("mise_token") });

const K = {
  card: "#ffffff", border: "#e8e2d8", text: "#2c2c2a", sub: "#6b6862",
  red: "#e24b4a", redSoft: "#fcebeb", redDark: "#791f1f",
  amber: "#ef9f27", amberSoft: "#faeeda", amberDark: "#633806",
  green: "#639922", greenSoft: "#eaf3de", greenDark: "#27500a",
  teal: "#1d9e75", tealSoft: "#e1f5ee", tealDark: "#04342c"
};

const fmtTimer = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(s / 60);
  if (m >= 60) return Math.floor(m / 60) + "h" + String(m % 60).padStart(2, "0");
  return String(m).padStart(2, "0") + ":" + String(s % 60).padStart(2, "0");
};
const timerColor = (ms) => { const m = ms / 60000; if (m < 10) return K.green; if (m < 20) return "#ba7517"; return "#a32d2d"; };

const tipoPedido = (o) => {
  if (o.mesa_id || o.order_type === "mesa") return { label: "MESA", icon: "🍽️", final: "servido", finalLabel: "✅ Servido" };
  if (["retirada", "pickup", "balcao"].includes(o.order_type)) return { label: "RETIRADA", icon: "🛍️", final: "retirado", finalLabel: "✅ Retirado" };
  return { label: "ENTREGA", icon: "🛵", final: "saiu_entrega", finalLabel: "🛵 Saiu p/ entrega" };
};

const CozinhaTab = ({ orders, loadOrders }) => {
  const audioCtx = useRef(null);
  const [somAtivo, setSomAtivo] = useState(false);
  const [, setTick] = useState(0);

  useEffect(() => { const t = setInterval(() => setTick(x => x + 1), 1000); return () => clearInterval(t); }, []);

  const beep = useCallback(() => {
    const ctx = audioCtx.current; if (!ctx) return;
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.connect(g); g.connect(ctx.destination);
    o.type = "square"; o.frequency.value = 880;
    g.gain.setValueAtTime(0.35, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
    o.start(); o.stop(ctx.currentTime + 0.4);
  }, []);

  const novos = orders.filter(o => o.status === "recebido");
  const temNaoVisto = novos.some(o => !o.seen_at);

  useEffect(() => {
    if (!somAtivo || !temNaoVisto) return;
    beep();
    const t = setInterval(beep, 2000);
    return () => clearInterval(t);
  }, [somAtivo, temNaoVisto, beep]);

  const ativarSom = () => {
    audioCtx.current = new (window.AudioContext || window.webkitAudioContext)();
    setSomAtivo(true);
  };

  const marcarVisto = async (o) => {
    if (o.seen_at) return;
    await fetch("/api/orders/" + o.id + "/seen", { method: "PATCH", headers: hdrs() });
    loadOrders();
  };

  const mudarStatus = async (o, status) => {
    await fetch("/api/orders/" + o.id + "/status", { method: "PATCH", headers: hdrs(), body: JSON.stringify({ status }) });
    loadOrders();
  };

  const preparo = orders.filter(o => o.status === "em_preparo");
  const prontos = orders.filter(o => o.status === "pronto");

  const Card = ({ o, coluna }) => {
    const tipo = tipoPedido(o);
    const inicio = coluna === "preparo" && o.preparing_at ? new Date(o.preparing_at) : new Date(o.created_at);
    const ms = Date.now() - inicio.getTime();
    const piscando = coluna === "novos";
    const btn = { width: "100%", padding: "12px 0", borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: "pointer", marginTop: 10 };
    return (
      <div onClick={() => piscando && marcarVisto(o)}
        style={{ background: K.card, borderRadius: 12, padding: 14, marginBottom: 12, cursor: piscando ? "pointer" : "default",
          border: piscando ? "2px solid " + K.red : "1px solid " + (coluna === "preparo" ? K.amber : K.teal),
          animation: piscando ? "kdsblink 1s ease-in-out infinite" : "none" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <span style={{ fontSize: 13, fontWeight: 700, padding: "4px 10px", borderRadius: 6,
            background: tipo.label === "MESA" ? K.tealSoft : tipo.label === "RETIRADA" ? K.amberSoft : K.redSoft,
            color: tipo.label === "MESA" ? K.tealDark : tipo.label === "RETIRADA" ? K.amberDark : K.redDark }}>
            {tipo.icon} {tipo.label}{o.mesa_nome ? " " + o.mesa_nome : ""}
          </span>
          {coluna !== "prontos" && (
            <span style={{ fontFamily: "monospace", fontSize: 16, fontWeight: 700, color: timerColor(ms) }}>⏱ {fmtTimer(ms)}</span>
          )}
        </div>
        <div style={{ fontSize: 17, fontWeight: 700, color: K.text }}>#{o.order_number} · {o.customer_name || "Cliente"}</div>
        {piscando && o.seen_at && <div style={{ fontSize: 12, color: K.redDark, marginTop: 2 }}>👁 visto — aguardando aceite</div>}
        <div style={{ marginTop: 10, borderTop: "1px solid " + K.border, paddingTop: 8 }}>
          {(o.items || []).map((it, i) => (
            <div key={i} style={{ marginBottom: 8 }}>
              <div style={{ fontSize: 15, color: K.text }}><b>{it.quantity}x</b> {it.name}</div>
              {it.selected_options && Object.keys(it.selected_options).length > 0 && (
                <div style={{ fontSize: 13, color: K.sub, marginLeft: 20 }}>
                  {Object.entries(it.selected_options).map(([k, v]) => k + ": " + (typeof v === "object" ? JSON.stringify(v) : v)).join(" · ")}
                </div>
              )}
              {it.selected_extras && it.selected_extras.length > 0 && (
                <div style={{ fontSize: 13, color: K.sub, marginLeft: 20 }}>
                  + {it.selected_extras.map(e => (e.qty > 1 ? e.qty + "x " : "") + (e.name || e.label || "")).join(", ")}
                </div>
              )}
              {it.notes && (
                <div style={{ fontSize: 14, fontWeight: 700, color: K.amberDark, background: K.amberSoft, padding: "4px 8px", borderRadius: 6, marginLeft: 20, marginTop: 3 }}>
                  ⚠️ {it.notes}
                </div>
              )}
            </div>
          ))}
          {o.notes && (
            <div style={{ fontSize: 14, fontWeight: 700, color: K.redDark, background: K.redSoft, padding: "6px 10px", borderRadius: 6, marginTop: 4 }}>
              📌 {o.notes}
            </div>
          )}
        </div>
        {coluna === "novos" && (
          <button onClick={(e) => { e.stopPropagation(); mudarStatus(o, "em_preparo"); }}
            style={{ ...btn, background: K.amberSoft, color: K.amberDark, border: "1px solid " + K.amber }}>
            👨‍🍳 Em preparo
          </button>
        )}
        {coluna === "preparo" && (
          <button onClick={() => mudarStatus(o, "pronto")}
            style={{ ...btn, background: K.greenSoft, color: K.greenDark, border: "1px solid " + K.green }}>
            ✅ Pronto
          </button>
        )}
        {coluna === "prontos" && (
          <button onClick={() => mudarStatus(o, tipo.final)}
            style={{ ...btn, background: K.tealSoft, color: K.tealDark, border: "1px solid " + K.teal }}>
            {tipo.finalLabel}
          </button>
        )}
      </div>
    );
  };

  const ColHeader = ({ label, count, color }) => (
    <div style={{ fontSize: 14, fontWeight: 700, color, marginBottom: 10 }}>{label} ({count})</div>
  );

  return (
    <div style={{ padding: 16 }}>
      <style>{"@keyframes kdsblink { 0%,100%{opacity:1} 50%{opacity:.55} }"}</style>
      {!somAtivo && (
        <button onClick={ativarSom}
          style={{ width: "100%", padding: 16, marginBottom: 16, borderRadius: 12, fontSize: 17, fontWeight: 700, cursor: "pointer",
            background: K.redSoft, color: K.redDark, border: "2px solid " + K.red }}>
          🔔 Toque aqui para ativar o som da cozinha
        </button>
      )}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 14 }}>
        <div>
          <ColHeader label="🔴 Novos" count={novos.length} color={K.redDark} />
          {novos.map(o => <Card key={o.id} o={o} coluna="novos" />)}
          {novos.length === 0 && <div style={{ fontSize: 13, color: K.sub }}>Nenhum pedido novo</div>}
        </div>
        <div>
          <ColHeader label="🔥 Em preparo" count={preparo.length} color={K.amberDark} />
          {preparo.map(o => <Card key={o.id} o={o} coluna="preparo" />)}
          {preparo.length === 0 && <div style={{ fontSize: 13, color: K.sub }}>Nada em preparo</div>}
        </div>
        <div>
          <ColHeader label="✅ Prontos" count={prontos.length} color={K.tealDark} />
          {prontos.map(o => <Card key={o.id} o={o} coluna="prontos" />)}
          {prontos.length === 0 && <div style={{ fontSize: 13, color: K.sub }}>Nenhum pronto</div>}
        </div>
      </div>
    </div>
  );
};

export default CozinhaTab;
